import { SHIPMENT_STATUS } from 'domains/customer-order/constants'
import SHIPMENT_METHOD from 'domains/customer-checkout/constants/checkout-shipment-method'

const CustomerOrderShipmentService = {

  /**
   * Check if the shipment is COD and the status is shipped
   * @param {object} shipment
   */
  isCodShipped         : (shipment) => shipment.order.is_cod && shipment.status === SHIPMENT_STATUS.SHIPPED,
  /**
   * Generate courier model based on 3rd party shipment response
   * Currently only available for GrabExpress
   * @returns object
   */
  generateCourierModel : (shipment, trackingResponse) => {
    const courierName = shipment.courier
    switch (courierName) {
      case SHIPMENT_METHOD.GRAB_EXPRESS: {
        const courierDetail = trackingResponse.courier

        return ({
          name         : courierDetail.name,
          phone        : courierDetail.phone,
          licensePlate : courierDetail.vehicle.licensePlate
        })
      }
      default:
        return ({
          name         : 'Tinkerlust courier',
          phone        : '628118705552',
          licensePlate : 'TL'
        })
    }
  }
}

export default CustomerOrderShipmentService
